import { forwardRef, OnChanges, OnInit, SimpleChange } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CompanyApi } from '@api/companies.api';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { getDistance } from 'geolib';
import { chain } from 'lodash';
import { debounceTime } from 'rxjs/operators';
import english from '../../../../main/maintenances/i18n/en.json';
import spanish from '../../../../main/maintenances/i18n/es.json';
import portuguese from '../../../../main/maintenances/i18n/pt.json';
export function ValidateAutocomplete() {
    return { required: true };
}
var INPUT_FIELD_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return CompaniesComponent; }),
    multi: true
};
var CompaniesComponent = /** @class */ (function () {
    function CompaniesComponent(companiesApi, fuseTranslationLoaderService) {
        this.companiesApi = companiesApi;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.floatLabel = true;
        this.preloadResults = false;
        this.appearance = 'outline';
        this.compareWithCoords = null;
        this.companies = [];
        this.inputValue = new FormControl();
        this.loading = false;
        this.options = {
            limit: 25,
            offset: 0,
            orderBy: 'name_asc'
        };
        this.onChange = function () { };
        this.onTouched = function () { };
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    CompaniesComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.disabled) {
            this.inputValue.disable();
        }
        if (this.required) {
            this.inputValue.setValidators(ValidateAutocomplete);
        }
        this.inputValue.valueChanges.pipe(debounceTime(500)).subscribe(function (value) {
            _this.companies = [];
            if (value || _this.preloadResults) {
                _this.searchCompanies(value || '');
            }
        });
    };
    CompaniesComponent.prototype.ngOnChanges = function (changes) {
        for (var propertyName in changes) {
            if (propertyName === 'disabled') {
                this.disabled = changes[propertyName].currentValue;
                this.disabled ? this.inputValue.disable() : this.inputValue.enable();
            }
        }
    };
    CompaniesComponent.prototype.searchCompanies = function (searchTerm) {
        var _this = this;
        var query = { name_contains: searchTerm && searchTerm.name ? searchTerm.name : searchTerm };
        var options = {
            limit: this.options.limit,
            offset: this.options.offset,
            orderBy: this.options.orderBy,
            orderByDistance: this.compareWithCoords && {
                direction: 'asc',
                distance: {
                    latitude: Number(this.compareWithCoords.latitude),
                    longitude: Number(this.compareWithCoords.longitude)
                }
            }
        };
        this.loading = true;
        this.companiesApi.search(query, options).subscribe(function (result) {
            _this.loading = false;
            if (!_this.compareWithCoords) {
                _this.companies = result.items;
                return;
            }
            _this.companies = chain(result.items)
                .map(function (item) {
                item.distance = item.address && item.address.coords.latitude && item.address.coords.longitude
                    ? getDistance(_this.compareWithCoords, item.address.coords)
                    : 0;
                item.name = _this.displayWithDistance(item);
                return item;
            })
                .sortBy('distance', 'asc')
                .value();
        });
    };
    CompaniesComponent.prototype.writeValue = function (companySelected) {
        var _this = this;
        if (companySelected) {
            this.companiesApi.searchOne(companySelected.id).then(function (company) {
                _this.selectedCompany = company;
                _this.inputValue.setErrors(null);
            });
        }
        else {
            this.deselectCompany();
        }
    };
    CompaniesComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    CompaniesComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    CompaniesComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
        if (isDisabled) {
            this.inputValue.disable();
        }
        else {
            this.inputValue.enable();
        }
    };
    CompaniesComponent.prototype.setSelectedCompany = function () {
        var _this = this;
        if (this.inputValue.value) {
            this.selectedCompany = this.companies.find(function (company) {
                return company.id === _this.inputValue.value.id;
            });
            this.onChange(this.inputValue.value);
            this.inputValue.setErrors(null);
        }
    };
    CompaniesComponent.prototype.deselectCompany = function () {
        this.onChange(null);
        this.selectedCompany = null;
        this.inputValue.setValue(null);
        this.inputValue.setErrors(null);
    };
    CompaniesComponent.prototype.displayWithDistance = function (value) {
        try {
            if (value.distance) {
                return value.name + " - (" + (value.distance / 1000).toFixed(2).replace('.', ',') + " km)";
            }
            return value.name;
        }
        catch (_a) {
            return null;
        }
    };
    return CompaniesComponent;
}());
export { CompaniesComponent };
